// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drag-handle {
  height: 30px;
  background-color: #ccc;
  cursor: ns-resize;
  width: 100%;
  border-radius: 10px 10px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: blue;
}

.drag-handle::before {
  content: "";
  width: 40px;
  height: 4px;
  background-color: #888;
  border-radius: 2px;
}
.google-map-container {
  position: relative;
  width: 100%;
}

.map-count-overlay {
  position: absolute;
  top: 10px;
  left: 1%;
  z-index: 1000;
  pointer-events: none !important;
}

.map-count-tag {
  color: #fff !important;
  font-size: 14px;
  font-weight: 600;
  padding: 6px 14px;
  border-radius: 6px;
  border: none;
  pointer-events: none !important;
}
.zoom-in-link {
  text-decoration: underline;
  cursor: pointer;
  pointer-events: auto !important;
}
/* Remove InfoWindow close (X) button */
.gm-ui-hover-effect {
  display: none !important;
}
.gm-style .gm-style-iw-c {
  padding: 0px !important;
}
/* Map overlay */
.map-count-overlay {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 5;
}

/* Google InfoWindow container */
.gm-style-iw,
.gm-style-iw-d {
  z-index: 999 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/map-view/GoogleMapsComponent.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,+BAA+B;AACjC;AACA,uCAAuC;AACvC;EACE,wBAAwB;AAC1B;AACA;EACE,uBAAuB;AACzB;AACA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;AACZ;;AAEA,gCAAgC;AAChC;;EAEE,uBAAuB;AACzB","sourcesContent":[".drag-handle {\n  height: 30px;\n  background-color: #ccc;\n  cursor: ns-resize;\n  width: 100%;\n  border-radius: 10px 10px 0 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: blue;\n}\n\n.drag-handle::before {\n  content: \"\";\n  width: 40px;\n  height: 4px;\n  background-color: #888;\n  border-radius: 2px;\n}\n.google-map-container {\n  position: relative;\n  width: 100%;\n}\n\n.map-count-overlay {\n  position: absolute;\n  top: 10px;\n  left: 1%;\n  z-index: 1000;\n  pointer-events: none !important;\n}\n\n.map-count-tag {\n  color: #fff !important;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 6px 14px;\n  border-radius: 6px;\n  border: none;\n  pointer-events: none !important;\n}\n.zoom-in-link {\n  text-decoration: underline;\n  cursor: pointer;\n  pointer-events: auto !important;\n}\n/* Remove InfoWindow close (X) button */\n.gm-ui-hover-effect {\n  display: none !important;\n}\n.gm-style .gm-style-iw-c {\n  padding: 0px !important;\n}\n/* Map overlay */\n.map-count-overlay {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  z-index: 5;\n}\n\n/* Google InfoWindow container */\n.gm-style-iw,\n.gm-style-iw-d {\n  z-index: 999 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
